import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import AddHolidayPopUp from "./add_holiday_popup.js";
import HolidayPopUp from "./holiday_popup.js";
import AddDeskReservation from "./addDeskReservation.js";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const HolidayUser = (props) => {
  const [monthName, setMonthName] = useState("");
  const [dateC, setDateC] = useState(props.date);
  const [showHolidayPopUp, setShowHolidayPopUp] = useState(false);
  const [holiday, setHoliday] = useState(null);
  const [showAddHolidayPopUp, setShowAddHolidayPopUp] = useState("");
  const [type, setType] = useState("");
  const [years, setYears] = useState([]);
  const [display, setDisplay] = useState("");
  const [expandRemote, setExpandRemote] = useState(false);
  const [expandSick, setExpandSick] = useState(false);
  const [expandUsed, setExpandUsed] = useState(false);
  const [expandAccepted, setExpandAccepted] = useState(false);
  const [expandReported, setExpandReported] = useState(false);
  const [showAddDeskReservation, setShowAddDeskReservation] = useState("");
  const [loading, setLoading] = useState(true);
  const [holidaysData, setHolidaysData] = useState([]);
  const [freeDaysData, setFreeDaysData] = useState([]);
  const [yearHolidaysData, setYearHolidaysData] = useState([]);
  const [holidaysBlockData, setHolidaysBlockData] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());

  const openAddHolidayPopUp = (e) => {
    setType(e.target.value);
    setShowAddHolidayPopUp(true);
  };

  const closeAddHolidayPopUp = (e) => {
    setType("");
    setShowAddHolidayPopUp(false);
    getData();
  };

  const openHolidayPopUp = (e) => {
    setShowHolidayPopUp(true);
    var value = e.currentTarget.attributes.value.nodeValue;
    setHoliday(holidaysData.filter((el) => el.id === value)[0]);
  };

  const openAddDeskReservation = (e) => {
    setShowAddDeskReservation(true);
    setShowHolidayPopUp(false);
    setShowAddHolidayPopUp(false);
  };

  const closeAddDeskReservation = (e) => {
    setType("");
    setShowAddDeskReservation(false);
    getData();
  };

  const closeHolidayPopUp = (e) => {
    setShowHolidayPopUp(false);
    setHoliday(null);
    getData();
  };

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const getMonthData = (monthNum) => {
    var data = props.monthData.filter((el) => +el.id === monthNum);
    return data.length > 0 ? data[0].name : "";
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;

    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else if (new Date(y, 0, d).getFullYear() === 2024) {
      return new Date(y, 0, d);
    } else if (y === 2025) {
      return subDays(new Date(y, 0, d), 2);
    } else {
      return new Date(y, 0, d);
    }
  };

  const createMonthSet = () => {
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var begin = new Date(year, month - 1, 1);
    var end = new Date(year, month, 0);
    var startYear = new Date(date).getFullYear();
    var yearStartDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((begin - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    var daysEnd = Math.floor((end - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumberEnd = Math.ceil(daysEnd / 7);
    var startDate = getDateOfWeek(weekNumber, startYear);
    var endDate = addDays(getDateOfWeek(weekNumberEnd, startYear), 6);

    var lastDay = end.getDate();
    var daysArray = [];
    var beginCounter = startDate;
    while (beginCounter >= startDate && beginCounter <= endDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() + 1
        }-${beginCounter.getDate()}`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }

    return daysArray;
  };

  const fetchHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysData(data);
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDaysData(data);
      })
      .catch((error) => {});
  };

  const fetchHolidaysBlocks = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidaysBlocks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysBlockData(data);
        fetchYearHolidays();
      })
      .catch((error) => {});
  };

  const fetchYearHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getYearsHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setYearHolidaysData(data);

        var yearsU = data.filter((el) => el.name === props.user.name);
        var arrY = [];
        yearsU.map((el) => {
          arrY.push(el.year);
        });

        setYears(arrY);

        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchHolidays();
    fetchFreeDays();
    fetchHolidaysBlocks();

    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    setMonthName(getMonthData(month) + " " + year);
  };

  useEffect(() => {
    getData();
  }, []);

  const total_days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24)) + 1;
    return TotalDays;
  };

  const checkFreeDay = (date) => {
    var bool = false;
    freeDaysData.map((el) => {
      if (
        date.getFullYear() +
          "-" +
          (date.getMonth() + 1 > 9
            ? date.getMonth() + 1
            : "0" + (date.getMonth() + 1)) +
          "-" +
          (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) ===
        el.date
      ) {
        bool = true;
      }
    });
    return bool;
  };

  const countDays = (holiday) => {
    var count = 0;
    for (
      var i = new Date(holiday.date_from);
      i <= new Date(holiday.date_to);
      i.setDate(i.getDate() + 1)
    ) {
      if (
        !(i.getDay() === 6) &&
        !(i.getDay() === 0) &&
        !checkFreeDay(i) &&
        +i.getFullYear() === +year
      ) {
        count++;
      }
    }
    return count;
  };

  const countDaysUsed = (holiday) => {
    var count = 0;
    for (
      var i = new Date(holiday.date_from);
      i <= new Date(holiday.date_to);
      i.setDate(i.getDate() + 1)
    ) {
      if (
        !(i.getDay() === 6 || i.getDay() === 0 || checkFreeDay(i)) &&
        +i.getFullYear() === +year
      ) {
        if (i < new Date()) {
          count++;
        }
      }
    }
    return count;
  };

  const getReportedDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "REPORTED" &&
        el.type === "holiday" &&
        new Date(el.date_from).getFullYear() === +year
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getReportedDaysMonth = (name, month) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "REPORTED" &&
        el.type === "holiday" &&
        new Date(el.date_to).getFullYear() === +year &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getAcceptedDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "holiday" &&
        new Date(el.date_from).getFullYear() === +year
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getAcceptedDaysMonth = (name, month) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "holiday" &&
        new Date(el.date_to).getFullYear() === +year &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el) - countDaysUsed(el);
    });
    return days;
  };

  const getUsedDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "holiday" &&
        new Date(el.date_from).getFullYear() === +year
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDaysUsed(el);
    });
    return days;
  };

  const getUsedDaysMonth = (name, month) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "holiday" &&
        new Date(el.date_to).getFullYear() === +year &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDaysUsed(el);
    });
    return days;
  };

  const getSickDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "sick" &&
        new Date(el.date_from).getFullYear() === +year
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getSickDaysMonth = (name, month) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "sick" &&
        new Date(el.date_to).getFullYear() === +year &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getRemoteDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "remote" &&
        new Date(el.date_from).getFullYear() === +year
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getEkwiwalentDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "ekwiwalent" &&
        new Date(el.date_to).getFullYear() === +year
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getRemoteDaysMonth = (name, month) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "remote" &&
        new Date(el.date_to).getFullYear() === +year &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const handleToggleMonth = (e) => {
    if (display === e.currentTarget.id) {
      setDisplay("");
    } else {
      setDisplay(e.currentTarget.id);
    }
  };

  const styleRowExp = { maxHeight: "100%" };

  const expandReportedBox = (e) => {
    setExpandReported(!expandReported);
    setExpandAccepted(false);
    setExpandUsed(false);
    setExpandRemote(false);
    setExpandSick(false);
  };

  const reportedHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandReportedBox}>
        {!expandReported ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandReported ? "expandShow" : "expandHidden"}>
        <div
          id="month1Reported"
          style={display === "month1Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getReportedDaysMonth(props.user.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Reported"
          style={display === "month2Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getReportedDaysMonth(props.user.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Reported"
          style={display === "month3Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getReportedDaysMonth(props.user.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Reported"
          style={display === "month4Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getReportedDaysMonth(props.user.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Reported"
          style={display === "month5Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getReportedDaysMonth(props.user.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Reported"
          style={display === "month6Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getReportedDaysMonth(props.user.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Reported"
          style={display === "month7Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getReportedDaysMonth(props.user.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Reported"
          style={display === "month8Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getReportedDaysMonth(props.user.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Reported"
          style={display === "month9Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getReportedDaysMonth(props.user.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Reported"
          style={display === "month10Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getReportedDaysMonth(props.user.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Reported"
          style={display === "month11Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getReportedDaysMonth(props.user.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Reported"
          style={display === "month12Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getReportedDaysMonth(props.user.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const expandAcceptedBox = (e) => {
    setExpandAccepted(!expandAccepted);
    setExpandReported(false);
    setExpandUsed(false);
    setExpandRemote(false);
    setExpandSick(false);
  };

  const acceptedHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandAcceptedBox}>
        {!expandAccepted ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandAccepted ? "expandShow" : "expandHidden"}>
        <div
          id="month1Accepted"
          style={display === "month1Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getAcceptedDaysMonth(props.user.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Accepted"
          style={display === "month2Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getAcceptedDaysMonth(props.user.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Accepted"
          style={display === "month3Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getAcceptedDaysMonth(props.user.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Accepted"
          style={display === "month4Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getAcceptedDaysMonth(props.user.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Accepted"
          style={display === "month5Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getAcceptedDaysMonth(props.user.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Accepted"
          style={display === "month6Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getAcceptedDaysMonth(props.user.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Accepted"
          style={display === "month7Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getAcceptedDaysMonth(props.user.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Accepted"
          style={display === "month8Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getAcceptedDaysMonth(props.user.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Accepted"
          style={display === "month9Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getAcceptedDaysMonth(props.user.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Accepted"
          style={display === "month10Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getAcceptedDaysMonth(props.user.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Accepted"
          style={display === "month11Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getAcceptedDaysMonth(props.user.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Accepted"
          style={display === "month12Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getAcceptedDaysMonth(props.user.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const expandUsedBox = (e) => {
    setExpandUsed(!expandUsed);
    setExpandReported(false);
    setExpandAccepted(false);
    setExpandRemote(false);
    setExpandSick(false);
  };

  const usedHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandUsedBox}>
        {!expandUsed ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandUsed ? "expandShow" : "expandHidden"}>
        <div
          id="month1Used"
          style={display === "month1Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getUsedDaysMonth(props.user.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Used"
          style={display === "month2Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getUsedDaysMonth(props.user.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Used"
          style={display === "month3Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getUsedDaysMonth(props.user.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Used"
          style={display === "month4Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getUsedDaysMonth(props.user.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Used"
          style={display === "month5Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getUsedDaysMonth(props.user.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Used"
          style={display === "month6Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getUsedDaysMonth(props.user.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Used"
          style={display === "month7Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getUsedDaysMonth(props.user.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Used"
          style={display === "month8Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getUsedDaysMonth(props.user.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Used"
          style={display === "month9Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getUsedDaysMonth(props.user.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Used"
          style={display === "month10Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getUsedDaysMonth(props.user.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Used"
          style={display === "month11Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getUsedDaysMonth(props.user.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Used"
          style={display === "month12Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getUsedDaysMonth(props.user.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const handleYearChange = (e) => {
    setLoading(true);
    setYear(e.target.value);
    setLoading(false);
  };

  const expandSickBox = (e) => {
    setExpandSick(!expandSick);
    setExpandReported(false);
    setExpandAccepted(false);
    setExpandRemote(false);
    setExpandUsed(false);
  };

  const sickHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandSickBox}>
        {!expandSick ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandSick ? "expandShow" : "expandHidden"}>
        <div
          id="month1Sick"
          style={display === "month1Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getSickDaysMonth(props.user.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Sick"
          style={display === "month2Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getSickDaysMonth(props.user.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Sick"
          style={display === "month3Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getSickDaysMonth(props.user.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Sick"
          style={display === "month4Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getSickDaysMonth(props.user.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Sick"
          style={display === "month5Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getSickDaysMonth(props.user.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Sick"
          style={display === "month6Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getSickDaysMonth(props.user.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Sick"
          style={display === "month7Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getSickDaysMonth(props.user.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Sick"
          style={display === "month8Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getSickDaysMonth(props.user.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Sick"
          style={display === "month9Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getSickDaysMonth(props.user.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Sick"
          style={display === "month10Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getSickDaysMonth(props.user.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Sick"
          style={display === "month11Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getSickDaysMonth(props.user.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Sick"
          style={display === "month12Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getSickDaysMonth(props.user.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const expandRemoteBox = (e) => {
    setExpandRemote(!expandRemote);
    setExpandReported(false);
    setExpandAccepted(false);
    setExpandSick(false);
    setExpandUsed(false);
  };

  const remoteHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandRemoteBox}>
        {!expandRemote ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandRemote ? "expandShow" : "expandHidden"}>
        <div
          id="month1Remote"
          style={display === "month1Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getRemoteDaysMonth(props.user.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Remote"
          style={display === "month2Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getRemoteDaysMonth(props.user.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Remote"
          style={display === "month3Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getRemoteDaysMonth(props.user.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Remote"
          style={display === "month4Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getRemoteDaysMonth(props.user.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Remote"
          style={display === "month5Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getRemoteDaysMonth(props.user.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Remote"
          style={display === "month6Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getRemoteDaysMonth(props.user.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Remote"
          style={display === "month7Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getRemoteDaysMonth(props.user.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Remote"
          style={display === "month8Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getRemoteDaysMonth(props.user.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Remote"
          style={display === "month9Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getRemoteDaysMonth(props.user.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Remote"
          style={display === "month10Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getRemoteDaysMonth(props.user.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Remote"
          style={display === "month11Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getRemoteDaysMonth(props.user.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Remote"
          style={display === "month12Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getRemoteDaysMonth(props.user.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === props.user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const getDays = () => {
    var data = props.yearHolidaysData.filter(
      (el) => el.name === props.user.name && +el.year === +year
    )[0];
    return data.days;
  };

  const calendarMonthNew = (
    <>
      {showAddDeskReservation ? (
        <AddDeskReservation
          close={closeAddDeskReservation}
          users={props.users}
          mode={"add"}
          holiday={props.holiday}
          user={props.user}
          holidaysData={holidaysData}
          holidaysBlockData={holidaysBlockData}
          holidaysSheetData={props.holidaysSheetData}
          refreshData={props.refreshData}
          team={props.team}
          type={type}
          date={props.date}
          freeDaysData={freeDaysData}
          deskResData={props.deskResData}
          desksData={props.desksData}
          deskResSheetData={props.deskResSheetData}
        />
      ) : (
        ""
      )}
      {showAddHolidayPopUp ? (
        <AddHolidayPopUp
          close={closeAddHolidayPopUp}
          users={props.users}
          mode={"add_user"}
          holiday={props.holiday}
          user={props.user}
          holidaysBlockData={holidaysBlockData}
          holidaysSheetData={props.holidaysSheetData}
          refreshData={props.refreshData}
          team={props.team}
          holidaysData={holidaysData}
          type={type}
        />
      ) : (
        ""
      )}
      {showHolidayPopUp ? (
        <HolidayPopUp
          close={closeHolidayPopUp}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockData={holidaysBlockData}
          refreshData={props.refreshData}
          users={props.users}
          user={props.user}
          mode="user"
          team={props.team}
          holidaysData={holidaysData}
        />
      ) : !showAddDeskReservation ? (
        <>
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>
              <div className="rowCalendar">
                <div className="rowHolidayUser">
                  <p>
                    ROK <span id="boldPartBig">{year}</span>
                  </p>
                  <p>
                    Ilość dni urlopu: <span id="boldPart">{getDays()}</span>
                  </p>
                  <p>
                    Ilość dni urlopu wnioskowanego:{" "}
                    <span id="boldPart">
                      {getReportedDays(props.user.name)}
                    </span>
                  </p>
                  <p>
                    Ilość dni urlopu zaakceptowanego:{" "}
                    <span id="boldPart">
                      {getAcceptedDays(props.user.name) -
                        getUsedDays(props.user.name) <
                      0
                        ? 0
                        : getAcceptedDays(props.user.name) -
                          getUsedDays(props.user.name)}
                    </span>
                  </p>
                  <p>
                    Ilość dni urlopu wykorzystanego:{" "}
                    <span id="boldPart">{getUsedDays(props.user.name)}</span>
                  </p>
                  <p>
                    Pozostałe dni urlopu:{" "}
                    <span id="boldPart">
                      {getDays(props.user.name) -
                        (getAcceptedDays(props.user.name) -
                          getUsedDays(props.user.name) +
                          getUsedDays(props.user.name) +
                          getReportedDays(props.user.name) +
                          getEkwiwalentDays(props.user.name))}
                    </span>
                  </p>
                  <br />
                  {getEkwiwalentDays(props.user.name) > 0 ? (
                    <>
                      <p className="main_h_info_label">
                        <span id="label_h">Wypłacony ekwiwalent: </span>
                        <span id="boldPartH">
                          {getEkwiwalentDays(props.user.name)}
                        </span>
                      </p>
                    </>
                  ) : (
                    ""
                  )}
                  <p>
                    Ilość dni zwolnienia chorobowego:{" "}
                    <span id="boldPart">{getSickDays(props.user.name)}</span>
                  </p>
                  {props.user.urlopyZdalna === 1 ? (
                    <p>
                      Ilość dni pracy zdalnej:{" "}
                      <span id="boldPart">
                        {getRemoteDays(props.user.name)}
                      </span>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="holidaysBox">
                <p className="holidayTitle">WNIOSKI URLOPOWE ZGŁOSZONE</p>
                {reportedHolidayData}
              </div>
              <div className="holidaysBox">
                <p className="holidayTitle">WNIOSKI URLOPOWE ZAAKCEPTOWANE</p>
                {acceptedHolidayData}
              </div>
              <div className="holidaysBox">
                <p className="holidayTitle">URLOP WYKORZYSTANY</p>
                {usedHolidayData}
              </div>
              <div className="holidaysBox">
                <p className="holidayTitle">ZWOLNIENIA CHOROBOWE</p>
                {sickHolidayData}
              </div>
              {+props.user.urlopyZdalna === 1 ? (
                <>
                  <div className="holidaysBox">
                    <p className="holidayTitle">OKRESY PRACY ZDALNEJ</p>
                    {remoteHolidayData}
                  </div>
                </>
              ) : (
                ""
              )}
            </>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <div className="mainContainerCalendar">
        <div className="holidayMenuContainer">
          <button
            className="paymentMenuButton"
            value="holiday"
            onClick={openAddHolidayPopUp}
          >
            Dodaj wniosek urlopowy
          </button>
          {+props.user.urlopyZdalna === 1 ? (
            <button
              className="paymentMenuButton"
              value="remote"
              onClick={openAddDeskReservation}
            >
              Dodaj pracę zdalną / zarezerwuj biurko
            </button>
          ) : (
            ""
          )}
        </div>
        <select
          type="text"
          id="filterO"
          name="court"
          value={year}
          onChange={handleYearChange}
        >
          {years.map((el) => (
            <option key={el} value={el}>
              {el}
            </option>
          ))}
        </select>
        {calendarMonthNew}
      </div>
    </>
  );
};

export default HolidayUser;
